import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { bindAll } from '@bibliocommons/utils-react';
import { catalogBibShape, recommendationShape } from '@bibliocommons/bc-prop-types';

import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectRecommendationsForCurrentBib } from 'app/selectors/bibs/DiscoverySelector';
import { trackContentClick } from 'app/actions/AnalyticsGa4Actions';
import { selectBibEntities } from 'app/selectors/EntitiesSelector';
import Recommendations from './Recommendations';

export class RecommendationsContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleClick(item) {
    const bibId = item.get('id');
    const providerName = item.get('providerName');
    const metadata = {
      metadata_category_type: 'bibliographic_details_title',
      metadata_value: this.props.bibs.getIn([bibId, 'briefInfo', 'title']),
      metadata_enrichment_provider: providerName?.toLowerCase() ?? undefined
    };
    const ui = {
      ui_container_type: 'section',
      ui_container_title: 'recommendation-you-may-also-like',
      ui_component_type: 'link-image'
    };

    this.props.trackContentClick({ bibId, metadata, ui });
  }

  render() {
    return <Recommendations {...this.props} handleClick={this.handleClick} />;
  }
}

RecommendationsContainer.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  recommendations: ImmutablePropTypes.listOf(recommendationShape).isRequired,
  trackContentClick: PropTypes.func,
  bibs: ImmutablePropTypes.map
};

const mapStateToProps = state => ({
  catalogBib: selectCatalogBib(state),
  recommendations: selectRecommendationsForCurrentBib(state),
  bibs: selectBibEntities(state)
});

const mapDispatchToProps = dispatch => ({
  trackContentClick: bindActionCreators(trackContentClick, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(RecommendationsContainer);
